import { InputText } from "primereact/inputtext"
import { useTranslation } from "react-i18next"

const EjercicioDeclaracion = ({ ejercicio }: { ejercicio?: number }) => {
  const { t } = useTranslation()

  return (
    <div className='tw-w-full tw-flex tw-flex-col tw-text-left'>
      <div className='tw-w-full tw-min-h-14 tw-p-0 tw-flex tw-justify-between tw-items-center tw-py-3 tw-border-t tw-border-b tw-border-neutral-25 tw-px-6'>
        <span className='tw-text-sm tw-font-normal'>
          {t("taxSummary.declaracion.devengoModelo.ejercicio")}
        </span>
        <InputText
          value={ejercicio}
          className='tw-text-sm'
          disabled
        />
      </div>
    </div>
  )
}
export default EjercicioDeclaracion
